
import { importSync as i } from '@embroider/macros';
let d = window.define;
d("mewe/templates/invite", function(){ return i("mewe/templates/invite.hbs");});
d("mewe/routes/invite", function(){ return i("mewe/routes/invite.js");});
